import { DataTestId, TextKey } from '@mews-commander/enums';
import { EnterpriseLink } from '@mews-commander/ui';
import { PaymentDetailsSidebarRow } from '../PaymentDetailsSidebarRow';
import { usePaymentDetailsSidebarContext } from '../../context/PaymentDetailsSidebarContext';

export const ReservationsDetails = () => {
    const { paymentDetails } = usePaymentDetailsSidebarContext();

    if (!paymentDetails?.serviceOrderId || !paymentDetails?.serviceOrderNumber) {
        return null;
    }

    const { serviceOrderId, serviceOrderNumber } = paymentDetails;

    return (
        <PaymentDetailsSidebarRow labelTextKey={TextKey.Reservation}>
            <EnterpriseLink
                to="Reservation/Detail/$reservationId"
                variant="basic"
                params={{ reservationId: serviceOrderId }}
                data-test-id={DataTestId.ReservationLink}
            >
                {serviceOrderNumber}
            </EnterpriseLink>
        </PaymentDetailsSidebarRow>
    );
};
